export class FeatureFlagService {
  static getApiKey() {
    switch (import.meta.env.VITE_ENV) {
      case 'dev':
        return '7c6d7b2e-f1b1-42d3-8de8-881dd8242ab4';
      case 'uat':
        return '6e04e3c6-b338-4599-a091-637f0b7dff59';
      case 'staging':
        return '8b4d2c8d-1f80-4f5b-a628-6871da0a65b8';
      case 'staging-sa':
        return '1833ad63-825c-4a82-8635-a12885939a05';
      case 'prod-sa':
        return '2a22296d-7c6f-4757-8a95-3172b04e0be1';
      case 'prod':
        return '6638860c-df6f-4703-a3c0-88ce7ad7f0fd';
      case 'prod-eu':
        return '2a98dbdc-78f2-442f-88a3-776009da97af';
      case 'prod-beta':
        return 'a8d2f48f-7b18-4bcd-bf0f-0ed08eeaa85f';
      default:
        return '7c6d7b2e-f1b1-42d3-8de8-881dd8242ab4';
    }
  }
}
